// removed by extract-text-webpack-plugin
module.exports = {"container":"_3xbLk","single":"_2czru","medium":"_1EB0G","search":"_2mzvI","large":"_3tFhP","membersArea":"_3xoQ5","date":"_27HWd","moreButton":"_3rXbM","icons":"_2mwEI","icon":"_2GWae","iconWrapper":"_1xL2F","status":"_12I_f","enter":"zJJgG","appear":"_1txAE","enterActive":"_37W2r","appearActive":"_16CaP"};


//////////////////
// WEBPACK FOOTER
// ./app/components/post-header/post-header.scss
// module id = 1067
// module chunks = 0 3 4 6